/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Button, IconButton, Paper, Typography, CircularProgress } from '@material-ui/core'
import { Clear } from '@material-ui/icons';

import Actions from '../../../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class MergeGroup extends Component {
    state = {
        merging_groups : false,
        merging_groups_error : false,
        merge_groups_complete : false
    }

    mergeGroups = () => {
        this.setState({...this.state, merging_groups : true, merging_groups_error : false, merge_groups_complete : false}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/merge_groups",
                method : "post",
                data : {    
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    merge_groups : this.props.groups.map(group => group.group_id)
                }
            }).then(res => {
                this.setState({...this.state, merging_groups : false, merging_groups_error : false, merge_groups_complete : true}, () => {
                    let pinned_groups = this.props.pinned_groups
                    let merged_group_id = res.data.result.Result.merged_group_id 
                    
                    console.log("IFC :: Pinned groups pre merge : ", pinned_groups)

                    let lost_group_id

                    this.props.groups.map(group => {
                        if (group.group_id !== merged_group_id) {
                            lost_group_id = group.group_id
                        }
                    })

                    let lost_group_index = pinned_groups.findIndex(group => group === lost_group_id)

                    if (lost_group_index !== -1) {
                        pinned_groups.splice(lost_group_index, 1)
                    }

                    console.log("IFC :: Pinned groups post merge : ", pinned_groups)

                    this.props.refresh_report(() => this.props.confirm_merge({field_in_focus: null, pinned_groups : pinned_groups}))
                })
            }).catch(err => {
                this.setState({...this.state, merging_groups : false, merging_groups_error : true, merge_groups_complete : false}, () => this.props.backdrop_enabler({backdrop_enable : false}))
            })
        })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper
                    square
                    elevation = {3}
                    style = {{
                        position : 'fixed',
                        width : '20vw',
                        top : '200px',
                        left : 'calc(25vw - 10vw)',
                        height : '145px',
                        zIndex : 12,
                    }}
                >
                    <div style = {{width : '100%', height : '30px', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center'}}>
                        <IconButton size = 'small' color = 'secondary' style = {{marginRight : '5px'}} onClick = {this.props.cancel_merge}>
                            <Clear fontSize = 'inherit'/>
                        </IconButton>
                    </div>
                    <div style = {{
                        width : '100%',
                        height : '70px',
                        display : 'flex',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        alignItems : 'center',
                        padding : '10px'
                    }}>
                        <Typography variant = 'body2' color = 'textSecondary' align = 'center'>{"Would you like to continue merging the " + this.props.group_display_name + "? This action cannot be reversed."}</Typography>
                    </div>
                    <div style = {{width : '100%', height : '45px', display : 'flex', flexDirection: 'row', alignItems : 'center', justifyContent : 'center',padding : '5px'}}>
                        <Button
                            color = 'primary'
                            size = 'small'
                            startIcon = {this.state.merging_groups && <CircularProgress variant = 'indeterminate' color = 'primary' size = {20}/>}  
                            onClick = {this.state.merging_groups ? null : this.mergeGroups} 
                        >
                           {this.state.merging_groups ? "Merging " + this.props.group_display_name : "Merge " + this.props.group_display_name}
                        </Button>
                    </div>
                </Paper>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(MergeGroup);